import { hexToBinary, SigningUtil } from '@streamr/utils';
import { KeyPairIdentity } from './KeyPairIdentity';
import { SignatureType } from '@streamr/trackerless-network';
const signingUtil = SigningUtil.getInstance('ML_DSA_87');
/**
 * An identity that uses a quantum-resistant ML-DSA-87 key pair to sign messages.
 */
export class MLDSAKeyPairIdentity extends KeyPairIdentity {
    assertValidKeyPair() {
        signingUtil.assertValidKeyPair(this.publicKey, this.privateKey);
    }
    // eslint-disable-next-line class-methods-use-this
    getSignatureType() {
        return SignatureType.ML_DSA_87;
    }
    async createMessageSignature(payload) {
        return signingUtil.createSignature(payload, this.privateKey);
    }
    /** @internal */
    static fromConfig(config) {
        const keyPairConfig = KeyPairIdentity.getKeyPairFromConfig(config);
        if (!keyPairConfig.publicKey) {
            throw new Error(`ML-DSA identity requires a publicKey to be given in the config!`);
        }
        return new MLDSAKeyPairIdentity(hexToBinary(keyPairConfig.publicKey), hexToBinary(keyPairConfig.privateKey));
    }
    static generate() {
        const keyPair = signingUtil.generateKeyPair();
        return new MLDSAKeyPairIdentity(keyPair.publicKey, keyPair.privateKey);
    }
}
//# sourceMappingURL=MLDSAKeyPairIdentity.js.map